import theme from 'theme'

const validateColor = (color) => {
  return color === '#' ? theme.palette.common.white : color
}

export default validateColor
